import { createCachedSelector, path, prop, stringComposeKeySelectors } from '@cbridge-utils/redux';
import { NetworkStatus } from '@cbridge-utils/network';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { INode, nodeStreamsSelector } from '@cbridge-packages/node';
import { IServer, serverSelector } from '@cbridge-packages/server';
import { compareStrings } from '@cbridge-utils/object';
import { selectedStreamIdSelector } from '../../_selectors/selectedStreamId.selector';

interface IStreamOption {
  streamId: number;
  name: string;
}

export const streamsFilterPropsSelector = createCachedSelector(
  [
    path(nodeStreamsSelector).networkStatus(),
    path(nodeStreamsSelector).streams(),
    path(serverSelector).streams(),
    path(serverSelector).networkStatus(),
    selectedStreamIdSelector,
    prop<{ nodeId: INode['nodeId'] }>().nodeId(),
    prop<{ serverId?: IServer['serverId'] }>().serverId(),
  ],
  (nodeNetworkStatus, nodeStreams, serverStreams, serverNetworkStatus, selectedStreamId, nodeId, serverId) => {
    const useServer = Boolean(serverId);
    const networkStatus = useServer ? serverNetworkStatus : nodeNetworkStatus;
    const streams: IStreamOption[] = useServer
      ? (serverStreams ?? []).map(s => ({ streamId: s.streamId, name: s.streamName }))
      : nodeStreams;

    return {
      isLoading: networkStatus === NetworkStatus.Started,
      items: streams
        .map(stream => ({
          label: stream.name,
          value: stream.streamId,
        }))
        .sort((a, b) => compareStrings(a.label, b.label)),
      hasOtherNodeSelection: selectedStreamId
        && nodeId != null
        && networkStatus === NetworkStatus.Done
        && !streams.some(({ streamId }) => selectedStreamId === streamId),
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: stringComposeKeySelectors(
    prop<{ nodeId: INode['nodeId'] }>().nodeId(),
    prop<{ serverId?: IServer['serverId'] }>().serverId(),
  ),
});
